import { render } from "./rights-users.vue?vue&type=template&id=194ce7dd&ts=true"
import script from "./rights-users.ts?vue&type=script&lang=ts&external"
export * from "./rights-users.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__